'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

export default function ScrollReset() {
  const pathname = usePathname()
  const lastPathname = useRef(pathname)
  const poppedPathname = useRef<string | null>(null)

  useEffect(() => {
    const onPopState = () => {
      poppedPathname.current = window.location.pathname
      const root = document.documentElement
      root.style.scrollBehavior = 'auto'
      window.setTimeout(() => {
        root.style.scrollBehavior = ''
      }, 1000)
    }
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  useEffect(() => {
    if (lastPathname.current === pathname) return
    lastPathname.current = pathname
    const restored = poppedPathname.current === pathname
    poppedPathname.current = null
    if (restored || window.location.hash) return
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
